import $ from 'jquery';

function pad(num) {
	num = parseInt(num, 10);

	return (num < 10) ? `0${num}` : String(num);
}

const instances = [];

function testimonials(selector = '.testimonials > .testimonials__wrap', settings = {}) {
	return $(selector).each((index, node) => {
		const $node = $(node);
		const $slides = $node.find('.testimonials__item');

		$node.on('init', (e, slick) => {
			const $prev = $node.find('.slick-prev').remove();
			const $next = $node.find('.slick-next').remove();
			if ($slides.length > 1) {
				$slides.each((index, slide) => {
					const $slideContent = $(slide).find('.testimonials__content');

					const $pager = $('<div class="pager testimonials__pager"></div>').appendTo($slideContent);
					$prev.clone().appendTo($pager);

					$(`<div class="pager__current">${pad(index + 1)}</div>`).appendTo($pager);
					$(`<div class="pager__total">${pad($slides.length)}</div>`).appendTo($pager);

					$next.clone().appendTo($pager);
				});

				$node.on('click', '.slick-prev', () => slick.slickPrev());
				$node.on('click', '.slick-next', () => slick.slickNext());
			}
		});

		let slider = $node.slick($.extend({
			adaptiveHeight: false,
			slidesToShow: 1,
			mobileFirst: true,
			speed: 300,
			touchThreshold: 5,
			arrows: true,
			cssEase: 'ease-in-out',

		}, settings));

		instances.push($node);
		window.gfi_sliders.push(slider);
	});
}

document.addEventListener('DOMContentLoaded', () => testimonials());

export default {
	testimonials,
	instances,
}
